export const generatedScenarioUncertaintyBudgetLedger = {
  "schemaVersion": 1,
  "generatedAt": "2026-06-21T00:00:00.000Z",
  "mode": "deterministic-scenario-uncertainty-budget-ledger",
  "operatingRule": "Every scenario uncertainty estimate must decompose modeled spread, assumption blockers, runtime gaps, source-use rights, economics evidence, and resource ambiguity before it can support business decisions.",
  "iterations": 256,
  "seed": "scenario-uncertainty-budget-v1",
  "scenarioCount": 6,
  "commercialUseAllowed": false,
  "promotionAllowed": false,
  "highestUncertaintyScenario": {
    "scenarioId": "mercury-orbit",
    "name": "Mercury Orbit-first",
    "rank": 4,
    "deterministicUtility": 42.95,
    "utilityP10": 39.63,
    "utilityMedian": 42.76,
    "utilityP90": 46.47,
    "winProbability": 0,
    "downsideSpread": 3.13,
    "uncertaintyBudgetPoints": 65.61,
    "uncertaintyClass": "high-uncertainty",
    "promotionAllowed": false,
    "allowedUse": "Decision-support uncertainty budgeting only; not a validated mission, investment, pricing, or resource forecast.",
    "topUncertaintyDrivers": [
      {
        "category": "model-spread",
        "label": "Seeded utility downside spread",
        "contributionPoints": 16,
        "evidenceState": "modeled-heuristic",
        "reducerProof": "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts.",
        "linkedEvidenceHash": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "contributionHash": "sha256-3a6bcd76e44b465731a5a7391ff59f7e8c4b01803bf85738d9eeacfda0260026"
      },
      {
        "category": "runtime-sidecar",
        "label": "Trajectory/event/runtime validation gap",
        "contributionPoints": 12,
        "evidenceState": "blocked-runtime-evidence",
        "reducerProof": "Promote runtime sidecar artifacts through the sidecar validation gate.",
        "linkedEvidenceHash": "sha256-aa8df127fd6f74cef0ba42b0ee62827380c4fb8d328808fd77d0793755c90b1f",
        "contributionHash": "sha256-4412801e7de2033a3dbe1195827c35d9004cdd53eef0996b14e8692497eb77af"
      },
      {
        "category": "assumption-sensitivity",
        "label": "Blocked or sensitive assumptions",
        "contributionPoints": 11.82,
        "evidenceState": "blocked-business-proof",
        "reducerProof": "Close assumption review gates with source-backed records and rerun assumption impact ledger.",
        "linkedEvidenceHash": "sha256-7e2ab79096a0b3d5feb1133e5b4ed52de40cfb5514b14423ab0bb85be208af00",
        "contributionHash": "sha256-c7a1e79ea5ee80f6e71b08dd891825dc28d5ad7f6a6250d69309b5965aa8aff6"
      },
      {
        "category": "resource-evidence",
        "label": "Body/feedstock composition uncertainty",
        "contributionPoints": 11,
        "evidenceState": "blocked-resource-promotion",
        "reducerProof": "Attach candidate/body-specific SBDB/CAD/taxonomy/spectra/mission data before resource promotion.",
        "linkedEvidenceHash": "sha256-3a4cf27fbcf60e16c76e5d5b2e16490e9dcfe393747d2678474c1f82d234af22",
        "contributionHash": "sha256-d23405c06a904d5d1e4f33ec35240bb179a08e65ed69c7c42149c071a8824cf7"
      }
    ],
    "contributors": [
      {
        "category": "model-spread",
        "label": "Seeded utility downside spread",
        "contributionPoints": 16,
        "evidenceState": "modeled-heuristic",
        "reducerProof": "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts.",
        "linkedEvidenceHash": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "contributionHash": "sha256-3a6bcd76e44b465731a5a7391ff59f7e8c4b01803bf85738d9eeacfda0260026"
      },
      {
        "category": "runtime-sidecar",
        "label": "Trajectory/event/runtime validation gap",
        "contributionPoints": 12,
        "evidenceState": "blocked-runtime-evidence",
        "reducerProof": "Promote runtime sidecar artifacts through the sidecar validation gate.",
        "linkedEvidenceHash": "sha256-aa8df127fd6f74cef0ba42b0ee62827380c4fb8d328808fd77d0793755c90b1f",
        "contributionHash": "sha256-4412801e7de2033a3dbe1195827c35d9004cdd53eef0996b14e8692497eb77af"
      },
      {
        "category": "assumption-sensitivity",
        "label": "Blocked or sensitive assumptions",
        "contributionPoints": 11.82,
        "evidenceState": "blocked-business-proof",
        "reducerProof": "Close assumption review gates with source-backed records and rerun assumption impact ledger.",
        "linkedEvidenceHash": "sha256-7e2ab79096a0b3d5feb1133e5b4ed52de40cfb5514b14423ab0bb85be208af00",
        "contributionHash": "sha256-c7a1e79ea5ee80f6e71b08dd891825dc28d5ad7f6a6250d69309b5965aa8aff6"
      },
      {
        "category": "resource-evidence",
        "label": "Body/feedstock composition uncertainty",
        "contributionPoints": 11,
        "evidenceState": "blocked-resource-promotion",
        "reducerProof": "Attach candidate/body-specific SBDB/CAD/taxonomy/spectra/mission data before resource promotion.",
        "linkedEvidenceHash": "sha256-3a4cf27fbcf60e16c76e5d5b2e16490e9dcfe393747d2678474c1f82d234af22",
        "contributionHash": "sha256-d23405c06a904d5d1e4f33ec35240bb179a08e65ed69c7c42149c071a8824cf7"
      },
      {
        "category": "source-use-rights",
        "label": "Customer report source-use clearance",
        "contributionPoints": 6.13,
        "evidenceState": "blocked-source-use-review",
        "reducerProof": "Approve source-use review packets before customer-facing redistribution or derived-value claims.",
        "linkedEvidenceHash": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57",
        "contributionHash": "sha256-b79ce22cfed14972f58df695a14e7409a7da576169983ac1c69b5a2f2cf33e4d"
      },
      {
        "category": "driver-volatility",
        "label": "Benefit/risk driver spread",
        "contributionPoints": 4.75,
        "evidenceState": "model-derived-heuristic",
        "reducerProof": "Replace broad planner scores with source-backed subsystem models and narrower uncertainty bands.",
        "linkedEvidenceHash": "sha256-3d2d82c36b7e046f9493f8b8f110374461d2bda863c9092e5df482160f350ab4",
        "contributionHash": "sha256-c792630152068637fe615b2c94e3c41940a5e11aa43a72692b38d79a7240fc31"
      },
      {
        "category": "economics-evidence",
        "label": "Dated economics source and normalization gap",
        "contributionPoints": 3.91,
        "evidenceState": "blocked-commercial-economics",
        "reducerProof": "Attach dated launch/capex/opex/market sources and calibrated economics artifacts.",
        "linkedEvidenceHash": "sha256-676c2d6d270fb909cf21a482178ffcf177df30d095d6c55f918afe08bf6a9297",
        "contributionHash": "sha256-1a1448b9e48171836408d94ef9da0b8e81bd738ec922514a13a77f4ed29520a9"
      }
    ],
    "reductionSequence": [
      {
        "order": 1,
        "category": "model-spread",
        "reducerProof": "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts.",
        "linkedEvidenceHash": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13"
      },
      {
        "order": 2,
        "category": "runtime-sidecar",
        "reducerProof": "Promote runtime sidecar artifacts through the sidecar validation gate.",
        "linkedEvidenceHash": "sha256-aa8df127fd6f74cef0ba42b0ee62827380c4fb8d328808fd77d0793755c90b1f"
      },
      {
        "order": 3,
        "category": "assumption-sensitivity",
        "reducerProof": "Close assumption review gates with source-backed records and rerun assumption impact ledger.",
        "linkedEvidenceHash": "sha256-7e2ab79096a0b3d5feb1133e5b4ed52de40cfb5514b14423ab0bb85be208af00"
      },
      {
        "order": 4,
        "category": "resource-evidence",
        "reducerProof": "Attach candidate/body-specific SBDB/CAD/taxonomy/spectra/mission data before resource promotion.",
        "linkedEvidenceHash": "sha256-3a4cf27fbcf60e16c76e5d5b2e16490e9dcfe393747d2678474c1f82d234af22"
      },
      {
        "order": 5,
        "category": "source-use-rights",
        "reducerProof": "Approve source-use review packets before customer-facing redistribution or derived-value claims.",
        "linkedEvidenceHash": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57"
      }
    ],
    "budgetHash": "sha256-70c464f33b48019386facb39aa0bfb479741a7cbb3dfba4dda52f3293de0512a"
  },
  "categoryTotals": {
    "model-spread": 77.36,
    "runtime-sidecar": 61,
    "assumption-sensitivity": 58,
    "source-use-rights": 36.78,
    "economics-evidence": 20.32,
    "resource-evidence": 42.1,
    "driver-volatility": 15.76
  },
  "evidenceHashes": {
    "scenarios": "sha256-e0d0a78ec49bf1456f7b884a37556bbea289f8740205e65d67dd3db12904089b",
    "defaultWeights": "sha256-5131a19946c87940b7042077430239d4ccf731cd2fe8966b65fa108782d2e6e9",
    "scenarioDecisionLedger": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
    "assumptionImpactLedger": "sha256-7e2ab79096a0b3d5feb1133e5b4ed52de40cfb5514b14423ab0bb85be208af00",
    "economicsFrontier": "sha256-e2d5dbb01f50cfbb0ccf93703eafd923ae088b68f6f757b3b1e20497ffac4adf",
    "economicsEvidenceLedger": "sha256-676c2d6d270fb909cf21a482178ffcf177df30d095d6c55f918afe08bf6a9297",
    "asteroidCandidateEvidenceLedger": "sha256-3a4cf27fbcf60e16c76e5d5b2e16490e9dcfe393747d2678474c1f82d234af22",
    "sidecarValidationReport": "sha256-aa8df127fd6f74cef0ba42b0ee62827380c4fb8d328808fd77d0793755c90b1f",
    "sourceUseRightsLedger": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57"
  },
  "budgets": [
    {
      "scenarioId": "moon-first",
      "name": "Moon-first Bootstrap",
      "rank": 1,
      "deterministicUtility": 67.12,
      "utilityP10": 65.24,
      "utilityMedian": 67.03,
      "utilityP90": 68.88,
      "winProbability": 74.61,
      "downsideSpread": 1.78,
      "uncertaintyBudgetPoints": 29.81,
      "uncertaintyClass": "managed-beta-uncertainty",
      "promotionAllowed": false,
      "allowedUse": "Decision-support uncertainty budgeting only; not a validated mission, investment, pricing, or resource forecast.",
      "topUncertaintyDrivers": [
        {
          "category": "model-spread",
          "label": "Seeded utility downside spread",
          "contributionPoints": 7.99,
          "evidenceState": "modeled-heuristic",
          "reducerProof": "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts.",
          "linkedEvidenceHash": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
          "contributionHash": "sha256-e7a820a5533b534b98eb2282a217d51581e38dab0711cf9ec220ba7993bab383"
        },
        {
          "category": "runtime-sidecar",
          "label": "Trajectory/event/runtime validation gap",
          "contributionPoints": 6.5,
          "evidenceState": "blocked-runtime-evidence",
          "reducerProof": "Promote runtime sidecar artifacts through the sidecar validation gate.",
          "linkedEvidenceHash": "sha256-aa8df127fd6f74cef0ba42b0ee62827380c4fb8d328808fd77d0793755c90b1f",
          "contributionHash": "sha256-d252d3d9ee2efe620e142b4d9d979748aff8a080a03247b343b412a2fac70d80"
        },
        {
          "category": "assumption-sensitivity",
          "label": "Blocked or sensitive assumptions",
          "contributionPoints": 6.44,
          "evidenceState": "blocked-business-proof",
          "reducerProof": "Close assumption review gates with source-backed records and rerun assumption impact ledger.",
          "linkedEvidenceHash": "sha256-7e2ab79096a0b3d5feb1133e5b4ed52de40cfb5514b14423ab0bb85be208af00",
          "contributionHash": "sha256-27860bb055c03086a261c1eb072bb63d5c7b6df40ac68d67afe85cc9d2f71730"
        },
        {
          "category": "source-use-rights",
          "label": "Customer report source-use clearance",
          "contributionPoints": 6.13,
          "evidenceState": "blocked-source-use-review",
          "reducerProof": "Approve source-use review packets before customer-facing redistribution or derived-value claims.",
          "linkedEvidenceHash": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57",
          "contributionHash": "sha256-b79ce22cfed14972f58df695a14e7409a7da576169983ac1c69b5a2f2cf33e4d"
        }
      ],
      "contributors": [
        {
          "category": "model-spread",
          "label": "Seeded utility downside spread",
          "contributionPoints": 7.99,
          "evidenceState": "modeled-heuristic",
          "reducerProof": "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts.",
          "linkedEvidenceHash": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
          "contributionHash": "sha256-e7a820a5533b534b98eb2282a217d51581e38dab0711cf9ec220ba7993bab383"
        },
        {
          "category": "runtime-sidecar",
          "label": "Trajectory/event/runtime validation gap",
          "contributionPoints": 6.5,
          "evidenceState": "blocked-runtime-evidence",
          "reducerProof": "Promote runtime sidecar artifacts through the sidecar validation gate.",
          "linkedEvidenceHash": "sha256-aa8df127fd6f74cef0ba42b0ee62827380c4fb8d328808fd77d0793755c90b1f",
          "contributionHash": "sha256-d252d3d9ee2efe620e142b4d9d979748aff8a080a03247b343b412a2fac70d80"
        },
        {
          "category": "assumption-sensitivity",
          "label": "Blocked or sensitive assumptions",
          "contributionPoints": 6.44,
          "evidenceState": "blocked-business-proof",
          "reducerProof": "Close assumption review gates with source-backed records and rerun assumption impact ledger.",
          "linkedEvidenceHash": "sha256-7e2ab79096a0b3d5feb1133e5b4ed52de40cfb5514b14423ab0bb85be208af00",
          "contributionHash": "sha256-27860bb055c03086a261c1eb072bb63d5c7b6df40ac68d67afe85cc9d2f71730"
        },
        {
          "category": "source-use-rights",
          "label": "Customer report source-use clearance",
          "contributionPoints": 6.13,
          "evidenceState": "blocked-source-use-review",
          "reducerProof": "Approve source-use review packets before customer-facing redistribution or derived-value claims.",
          "linkedEvidenceHash": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57",
          "contributionHash": "sha256-b79ce22cfed14972f58df695a14e7409a7da576169983ac1c69b5a2f2cf33e4d"
        },
        {
          "category": "economics-evidence",
          "label": "Dated economics source and normalization gap",
          "contributionPoints": 3,
          "evidenceState": "blocked-commercial-economics",
          "reducerProof": "Attach dated launch/capex/opex/market sources and calibrated economics artifacts.",
          "linkedEvidenceHash": "sha256-676c2d6d270fb909cf21a482178ffcf177df30d095d6c55f918afe08bf6a9297",
          "contributionHash": "sha256-8179812de2f8d4df5c0cafaf831ef3aa67f455b4776b724bf48468f07f56f02b"
        },
        {
          "category": "resource-evidence",
          "label": "Body/feedstock composition uncertainty",
          "contributionPoints": 0,
          "evidenceState": "not-primary-driver",
          "reducerProof": "Attach candidate/body-specific SBDB/CAD/taxonomy/spectra/mission data before resource promotion.",
          "linkedEvidenceHash": "sha256-3a4cf27fbcf60e16c76e5d5b2e16490e9dcfe393747d2678474c1f82d234af22",
          "contributionHash": "sha256-66a069c6ea75e49cd6d2dc4dfdd1078bc5dc1ae19021a2541d08c9194cf287c0"
        },
        {
          "category": "driver-volatility",
          "label": "Benefit/risk driver spread",
          "contributionPoints": -0.25,
          "evidenceState": "model-derived-heuristic",
          "reducerProof": "Replace broad planner scores with source-backed subsystem models and narrower uncertainty bands.",
          "linkedEvidenceHash": "sha256-10d9dbf8c908ecc11f38b876ad8b0973845d4b803124a1ce5d524cdd72f1422c",
          "contributionHash": "sha256-bb3f223cfd7ca397e791f5b0750698658f330b1e6a43c4d5352f953806058a6d"
        }
      ],
      "reductionSequence": [
        {
          "order": 1,
          "category": "model-spread",
          "reducerProof": "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts.",
          "linkedEvidenceHash": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13"
        },
        {
          "order": 2,
          "category": "runtime-sidecar",
          "reducerProof": "Promote runtime sidecar artifacts through the sidecar validation gate.",
          "linkedEvidenceHash": "sha256-aa8df127fd6f74cef0ba42b0ee62827380c4fb8d328808fd77d0793755c90b1f"
        },
        {
          "order": 3,
          "category": "assumption-sensitivity",
          "reducerProof": "Close assumption review gates with source-backed records and rerun assumption impact ledger.",
          "linkedEvidenceHash": "sha256-7e2ab79096a0b3d5feb1133e5b4ed52de40cfb5514b14423ab0bb85be208af00"
        },
        {
          "order": 4,
          "category": "source-use-rights",
          "reducerProof": "Approve source-use review packets before customer-facing redistribution or derived-value claims.",
          "linkedEvidenceHash": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57"
        },
        {
          "order": 5,
          "category": "economics-evidence",
          "reducerProof": "Attach dated launch/capex/opex/market sources and calibrated economics artifacts.",
          "linkedEvidenceHash": "sha256-676c2d6d270fb909cf21a482178ffcf177df30d095d6c55f918afe08bf6a9297"
        }
      ],
      "budgetHash": "sha256-7500ba6f2d84d04fb1ca29f147b51a1837dea22ff94c58685f367d997e50a621"
    },
    {
      "scenarioId": "hybrid",
      "name": "Hybrid Moon -> Asteroid -> Mercury",
      "rank": 2,
      "deterministicUtility": 65.69,
      "utilityP10": 63.32,
      "utilityMedian": 65.48,
      "utilityP90": 67.6,
      "winProbability": 25.39,
      "downsideSpread": 2.17,
      "uncertaintyBudgetPoints": 43.88,
      "uncertaintyClass": "medium-uncertainty",
      "promotionAllowed": false,
      "allowedUse": "Decision-support uncertainty budgeting only; not a validated mission, investment, pricing, or resource forecast.",
      "topUncertaintyDrivers": [
        {
          "category": "model-spread",
          "label": "Seeded utility downside spread",
          "contributionPoints": 10.68,
          "evidenceState": "modeled-heuristic",
          "reducerProof": "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts.",
          "linkedEvidenceHash": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
          "contributionHash": "sha256-1113356c45a9d66efb46dd79ad7e995ce35753fd92106e8a62a123e46e0c609a"
        },
        {
          "category": "assumption-sensitivity",
          "label": "Blocked or sensitive assumptions",
          "contributionPoints": 9.66,
          "evidenceState": "blocked-business-proof",
          "reducerProof": "Close assumption review gates with source-backed records and rerun assumption impact ledger.",
          "linkedEvidenceHash": "sha256-7e2ab79096a0b3d5feb1133e5b4ed52de40cfb5514b14423ab0bb85be208af00",
          "contributionHash": "sha256-4e70a0f224a6884c44ccdf9a653d574034fb8de4a78ea8dafb4b627c42b51d72"
        },
        {
          "category": "resource-evidence",
          "label": "Body/feedstock composition uncertainty",
          "contributionPoints": 9.5,
          "evidenceState": "blocked-resource-promotion",
          "reducerProof": "Attach candidate/body-specific SBDB/CAD/taxonomy/spectra/mission data before resource promotion.",
          "linkedEvidenceHash": "sha256-3a4cf27fbcf60e16c76e5d5b2e16490e9dcfe393747d2678474c1f82d234af22",
          "contributionHash": "sha256-07a08f8b629617090c595a9abaae19c858d1033775537f967bec618d3b525523"
        },
        {
          "category": "runtime-sidecar",
          "label": "Trajectory/event/runtime validation gap",
          "contributionPoints": 6.5,
          "evidenceState": "blocked-runtime-evidence",
          "reducerProof": "Promote runtime sidecar artifacts through the sidecar validation gate.",
          "linkedEvidenceHash": "sha256-aa8df127fd6f74cef0ba42b0ee62827380c4fb8d328808fd77d0793755c90b1f",
          "contributionHash": "sha256-d252d3d9ee2efe620e142b4d9d979748aff8a080a03247b343b412a2fac70d80"
        }
      ],
      "contributors": [
        {
          "category": "model-spread",
          "label": "Seeded utility downside spread",
          "contributionPoints": 10.68,
          "evidenceState": "modeled-heuristic",
          "reducerProof": "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts.",
          "linkedEvidenceHash": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
          "contributionHash": "sha256-1113356c45a9d66efb46dd79ad7e995ce35753fd92106e8a62a123e46e0c609a"
        },
        {
          "category": "assumption-sensitivity",
          "label": "Blocked or sensitive assumptions",
          "contributionPoints": 9.66,
          "evidenceState": "blocked-business-proof",
          "reducerProof": "Close assumption review gates with source-backed records and rerun assumption impact ledger.",
          "linkedEvidenceHash": "sha256-7e2ab79096a0b3d5feb1133e5b4ed52de40cfb5514b14423ab0bb85be208af00",
          "contributionHash": "sha256-4e70a0f224a6884c44ccdf9a653d574034fb8de4a78ea8dafb4b627c42b51d72"
        },
        {
          "category": "resource-evidence",
          "label": "Body/feedstock composition uncertainty",
          "contributionPoints": 9.5,
          "evidenceState": "blocked-resource-promotion",
          "reducerProof": "Attach candidate/body-specific SBDB/CAD/taxonomy/spectra/mission data before resource promotion.",
          "linkedEvidenceHash": "sha256-3a4cf27fbcf60e16c76e5d5b2e16490e9dcfe393747d2678474c1f82d234af22",
          "contributionHash": "sha256-07a08f8b629617090c595a9abaae19c858d1033775537f967bec618d3b525523"
        },
        {
          "category": "runtime-sidecar",
          "label": "Trajectory/event/runtime validation gap",
          "contributionPoints": 6.5,
          "evidenceState": "blocked-runtime-evidence",
          "reducerProof": "Promote runtime sidecar artifacts through the sidecar validation gate.",
          "linkedEvidenceHash": "sha256-aa8df127fd6f74cef0ba42b0ee62827380c4fb8d328808fd77d0793755c90b1f",
          "contributionHash": "sha256-d252d3d9ee2efe620e142b4d9d979748aff8a080a03247b343b412a2fac70d80"
        },
        {
          "category": "source-use-rights",
          "label": "Customer report source-use clearance",
          "contributionPoints": 6.13,
          "evidenceState": "blocked-source-use-review",
          "reducerProof": "Approve source-use review packets before customer-facing redistribution or derived-value claims.",
          "linkedEvidenceHash": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57",
          "contributionHash": "sha256-b79ce22cfed14972f58df695a14e7409a7da576169983ac1c69b5a2f2cf33e4d"
        },
        {
          "category": "economics-evidence",
          "label": "Dated economics source and normalization gap",
          "contributionPoints": 3.03,
          "evidenceState": "blocked-commercial-economics",
          "reducerProof": "Attach dated launch/capex/opex/market sources and calibrated economics artifacts.",
          "linkedEvidenceHash": "sha256-676c2d6d270fb909cf21a482178ffcf177df30d095d6c55f918afe08bf6a9297",
          "contributionHash": "sha256-e369479e1a5d24f252cc694e901e18eea5c25e555b2f0bd4f14cbbba4ee5b072"
        },
        {
          "category": "driver-volatility",
          "label": "Benefit/risk driver spread",
          "contributionPoints": -1.62,
          "evidenceState": "model-derived-heuristic",
          "reducerProof": "Replace broad planner scores with source-backed subsystem models and narrower uncertainty bands.",
          "linkedEvidenceHash": "sha256-d1291337540a1d709dbf14299fe94a0c514a6f2fdc474b3eceec237a4bb9b803",
          "contributionHash": "sha256-c093cbda2d4793a8d1136d7a9883904828df06ee02a22226fdcfa2dce04e8f5e"
        }
      ],
      "reductionSequence": [
        {
          "order": 1,
          "category": "model-spread",
          "reducerProof": "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts.",
          "linkedEvidenceHash": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13"
        },
        {
          "order": 2,
          "category": "assumption-sensitivity",
          "reducerProof": "Close assumption review gates with source-backed records and rerun assumption impact ledger.",
          "linkedEvidenceHash": "sha256-7e2ab79096a0b3d5feb1133e5b4ed52de40cfb5514b14423ab0bb85be208af00"
        },
        {
          "order": 3,
          "category": "resource-evidence",
          "reducerProof": "Attach candidate/body-specific SBDB/CAD/taxonomy/spectra/mission data before resource promotion.",
          "linkedEvidenceHash": "sha256-3a4cf27fbcf60e16c76e5d5b2e16490e9dcfe393747d2678474c1f82d234af22"
        },
        {
          "order": 4,
          "category": "runtime-sidecar",
          "reducerProof": "Promote runtime sidecar artifacts through the sidecar validation gate.",
          "linkedEvidenceHash": "sha256-aa8df127fd6f74cef0ba42b0ee62827380c4fb8d328808fd77d0793755c90b1f"
        },
        {
          "order": 5,
          "category": "source-use-rights",
          "reducerProof": "Approve source-use review packets before customer-facing redistribution or derived-value claims.",
          "linkedEvidenceHash": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57"
        }
      ],
      "budgetHash": "sha256-d595ef57fc29b1e7bf00950455c56c83e9f708dd12dd6c63c2d8c22b72a89869"
    },
    {
      "scenarioId": "asteroid-first",
      "name": "Asteroid Feedstock-first",
      "rank": 3,
      "deterministicUtility": 51.37,
      "utilityP10": 48.31,
      "utilityMedian": 51.44,
      "utilityP90": 54.65,
      "winProbability": 0,
      "downsideSpread": 3.13,
      "uncertaintyBudgetPoints": 62.38,
      "uncertaintyClass": "high-uncertainty",
      "promotionAllowed": false,
      "allowedUse": "Decision-support uncertainty budgeting only; not a validated mission, investment, pricing, or resource forecast.",
      "topUncertaintyDrivers": [
        {
          "category": "model-spread",
          "label": "Seeded utility downside spread",
          "contributionPoints": 15.7,
          "evidenceState": "modeled-heuristic",
          "reducerProof": "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts.",
          "linkedEvidenceHash": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
          "contributionHash": "sha256-62290db47bb715a394703feface42956bd76762cc46e41871be2d4c6088926f8"
        },
        {
          "category": "runtime-sidecar",
          "label": "Trajectory/event/runtime validation gap",
          "contributionPoints": 12,
          "evidenceState": "blocked-runtime-evidence",
          "reducerProof": "Promote runtime sidecar artifacts through the sidecar validation gate.",
          "linkedEvidenceHash": "sha256-aa8df127fd6f74cef0ba42b0ee62827380c4fb8d328808fd77d0793755c90b1f",
          "contributionHash": "sha256-4412801e7de2033a3dbe1195827c35d9004cdd53eef0996b14e8692497eb77af"
        },
        {
          "category": "resource-evidence",
          "label": "Body/feedstock composition uncertainty",
          "contributionPoints": 11.2,
          "evidenceState": "blocked-resource-promotion",
          "reducerProof": "Attach candidate/body-specific SBDB/CAD/taxonomy/spectra/mission data before resource promotion.",
          "linkedEvidenceHash": "sha256-3a4cf27fbcf60e16c76e5d5b2e16490e9dcfe393747d2678474c1f82d234af22",
          "contributionHash": "sha256-2c261a74b574903f533b54dbb876ed54b89344637cb324d566afd587e6fb1ec9"
        },
        {
          "category": "assumption-sensitivity",
          "label": "Blocked or sensitive assumptions",
          "contributionPoints": 10.74,
          "evidenceState": "blocked-business-proof",
          "reducerProof": "Close assumption review gates with source-backed records and rerun assumption impact ledger.",
          "linkedEvidenceHash": "sha256-7e2ab79096a0b3d5feb1133e5b4ed52de40cfb5514b14423ab0bb85be208af00",
          "contributionHash": "sha256-4d1eb074e43d03e1bb3481de720554475dcffbd6811c616684e790a98fc50a62"
        }
      ],
      "contributors": [
        {
          "category": "model-spread",
          "label": "Seeded utility downside spread",
          "contributionPoints": 15.7,
          "evidenceState": "modeled-heuristic",
          "reducerProof": "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts.",
          "linkedEvidenceHash": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
          "contributionHash": "sha256-62290db47bb715a394703feface42956bd76762cc46e41871be2d4c6088926f8"
        },
        {
          "category": "runtime-sidecar",
          "label": "Trajectory/event/runtime validation gap",
          "contributionPoints": 12,
          "evidenceState": "blocked-runtime-evidence",
          "reducerProof": "Promote runtime sidecar artifacts through the sidecar validation gate.",
          "linkedEvidenceHash": "sha256-aa8df127fd6f74cef0ba42b0ee62827380c4fb8d328808fd77d0793755c90b1f",
          "contributionHash": "sha256-4412801e7de2033a3dbe1195827c35d9004cdd53eef0996b14e8692497eb77af"
        },
        {
          "category": "resource-evidence",
          "label": "Body/feedstock composition uncertainty",
          "contributionPoints": 11.2,
          "evidenceState": "blocked-resource-promotion",
          "reducerProof": "Attach candidate/body-specific SBDB/CAD/taxonomy/spectra/mission data before resource promotion.",
          "linkedEvidenceHash": "sha256-3a4cf27fbcf60e16c76e5d5b2e16490e9dcfe393747d2678474c1f82d234af22",
          "contributionHash": "sha256-2c261a74b574903f533b54dbb876ed54b89344637cb324d566afd587e6fb1ec9"
        },
        {
          "category": "assumption-sensitivity",
          "label": "Blocked or sensitive assumptions",
          "contributionPoints": 10.74,
          "evidenceState": "blocked-business-proof",
          "reducerProof": "Close assumption review gates with source-backed records and rerun assumption impact ledger.",
          "linkedEvidenceHash": "sha256-7e2ab79096a0b3d5feb1133e5b4ed52de40cfb5514b14423ab0bb85be208af00",
          "contributionHash": "sha256-4d1eb074e43d03e1bb3481de720554475dcffbd6811c616684e790a98fc50a62"
        },
        {
          "category": "source-use-rights",
          "label": "Customer report source-use clearance",
          "contributionPoints": 6.13,
          "evidenceState": "blocked-source-use-review",
          "reducerProof": "Approve source-use review packets before customer-facing redistribution or derived-value claims.",
          "linkedEvidenceHash": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57",
          "contributionHash": "sha256-b79ce22cfed14972f58df695a14e7409a7da576169983ac1c69b5a2f2cf33e4d"
        },
        {
          "category": "driver-volatility",
          "label": "Benefit/risk driver spread",
          "contributionPoints": 3.38,
          "evidenceState": "model-derived-heuristic",
          "reducerProof": "Replace broad planner scores with source-backed subsystem models and narrower uncertainty bands.",
          "linkedEvidenceHash": "sha256-d9790d0c91f9265c9681ca6b04883b642500ac3e7a16d26dbf169e61ea5bd051",
          "contributionHash": "sha256-9bf7d0eccc148eb70853448f5c26abd7e47e742ebeccd8e444e2d43f77f61366"
        },
        {
          "category": "economics-evidence",
          "label": "Dated economics source and normalization gap",
          "contributionPoints": 3.23,
          "evidenceState": "blocked-commercial-economics",
          "reducerProof": "Attach dated launch/capex/opex/market sources and calibrated economics artifacts.",
          "linkedEvidenceHash": "sha256-676c2d6d270fb909cf21a482178ffcf177df30d095d6c55f918afe08bf6a9297",
          "contributionHash": "sha256-5d7ace780c36f57cedac4e37d5babeeb412f9700f1ef01e136bea3c4c8b59d81"
        }
      ],
      "reductionSequence": [
        {
          "order": 1,
          "category": "model-spread",
          "reducerProof": "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts.",
          "linkedEvidenceHash": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13"
        },
        {
          "order": 2,
          "category": "runtime-sidecar",
          "reducerProof": "Promote runtime sidecar artifacts through the sidecar validation gate.",
          "linkedEvidenceHash": "sha256-aa8df127fd6f74cef0ba42b0ee62827380c4fb8d328808fd77d0793755c90b1f"
        },
        {
          "order": 3,
          "category": "resource-evidence",
          "reducerProof": "Attach candidate/body-specific SBDB/CAD/taxonomy/spectra/mission data before resource promotion.",
          "linkedEvidenceHash": "sha256-3a4cf27fbcf60e16c76e5d5b2e16490e9dcfe393747d2678474c1f82d234af22"
        },
        {
          "order": 4,
          "category": "assumption-sensitivity",
          "reducerProof": "Close assumption review gates with source-backed records and rerun assumption impact ledger.",
          "linkedEvidenceHash": "sha256-7e2ab79096a0b3d5feb1133e5b4ed52de40cfb5514b14423ab0bb85be208af00"
        },
        {
          "order": 5,
          "category": "source-use-rights",
          "reducerProof": "Approve source-use review packets before customer-facing redistribution or derived-value claims.",
          "linkedEvidenceHash": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57"
        }
      ],
      "budgetHash": "sha256-aeeeb361235a90a7df3c4136154cb8901a3573712450f7d0879a212ebf0fe17a"
    },
    {
      "scenarioId": "mercury-orbit",
      "name": "Mercury Orbit-first",
      "rank": 4,
      "deterministicUtility": 42.95,
      "utilityP10": 39.63,
      "utilityMedian": 42.76,
      "utilityP90": 46.47,
      "winProbability": 0,
      "downsideSpread": 3.13,
      "uncertaintyBudgetPoints": 65.61,
      "uncertaintyClass": "high-uncertainty",
      "promotionAllowed": false,
      "allowedUse": "Decision-support uncertainty budgeting only; not a validated mission, investment, pricing, or resource forecast.",
      "topUncertaintyDrivers": [
        {
          "category": "model-spread",
          "label": "Seeded utility downside spread",
          "contributionPoints": 16,
          "evidenceState": "modeled-heuristic",
          "reducerProof": "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts.",
          "linkedEvidenceHash": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
          "contributionHash": "sha256-3a6bcd76e44b465731a5a7391ff59f7e8c4b01803bf85738d9eeacfda0260026"
        },
        {
          "category": "runtime-sidecar",
          "label": "Trajectory/event/runtime validation gap",
          "contributionPoints": 12,
          "evidenceState": "blocked-runtime-evidence",
          "reducerProof": "Promote runtime sidecar artifacts through the sidecar validation gate.",
          "linkedEvidenceHash": "sha256-aa8df127fd6f74cef0ba42b0ee62827380c4fb8d328808fd77d0793755c90b1f",
          "contributionHash": "sha256-4412801e7de2033a3dbe1195827c35d9004cdd53eef0996b14e8692497eb77af"
        },
        {
          "category": "assumption-sensitivity",
          "label": "Blocked or sensitive assumptions",
          "contributionPoints": 11.82,
          "evidenceState": "blocked-business-proof",
          "reducerProof": "Close assumption review gates with source-backed records and rerun assumption impact ledger.",
          "linkedEvidenceHash": "sha256-7e2ab79096a0b3d5feb1133e5b4ed52de40cfb5514b14423ab0bb85be208af00",
          "contributionHash": "sha256-c7a1e79ea5ee80f6e71b08dd891825dc28d5ad7f6a6250d69309b5965aa8aff6"
        },
        {
          "category": "resource-evidence",
          "label": "Body/feedstock composition uncertainty",
          "contributionPoints": 11,
          "evidenceState": "blocked-resource-promotion",
          "reducerProof": "Attach candidate/body-specific SBDB/CAD/taxonomy/spectra/mission data before resource promotion.",
          "linkedEvidenceHash": "sha256-3a4cf27fbcf60e16c76e5d5b2e16490e9dcfe393747d2678474c1f82d234af22",
          "contributionHash": "sha256-d23405c06a904d5d1e4f33ec35240bb179a08e65ed69c7c42149c071a8824cf7"
        }
      ],
      "contributors": [
        {
          "category": "model-spread",
          "label": "Seeded utility downside spread",
          "contributionPoints": 16,
          "evidenceState": "modeled-heuristic",
          "reducerProof": "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts.",
          "linkedEvidenceHash": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
          "contributionHash": "sha256-3a6bcd76e44b465731a5a7391ff59f7e8c4b01803bf85738d9eeacfda0260026"
        },
        {
          "category": "runtime-sidecar",
          "label": "Trajectory/event/runtime validation gap",
          "contributionPoints": 12,
          "evidenceState": "blocked-runtime-evidence",
          "reducerProof": "Promote runtime sidecar artifacts through the sidecar validation gate.",
          "linkedEvidenceHash": "sha256-aa8df127fd6f74cef0ba42b0ee62827380c4fb8d328808fd77d0793755c90b1f",
          "contributionHash": "sha256-4412801e7de2033a3dbe1195827c35d9004cdd53eef0996b14e8692497eb77af"
        },
        {
          "category": "assumption-sensitivity",
          "label": "Blocked or sensitive assumptions",
          "contributionPoints": 11.82,
          "evidenceState": "blocked-business-proof",
          "reducerProof": "Close assumption review gates with source-backed records and rerun assumption impact ledger.",
          "linkedEvidenceHash": "sha256-7e2ab79096a0b3d5feb1133e5b4ed52de40cfb5514b14423ab0bb85be208af00",
          "contributionHash": "sha256-c7a1e79ea5ee80f6e71b08dd891825dc28d5ad7f6a6250d69309b5965aa8aff6"
        },
        {
          "category": "resource-evidence",
          "label": "Body/feedstock composition uncertainty",
          "contributionPoints": 11,
          "evidenceState": "blocked-resource-promotion",
          "reducerProof": "Attach candidate/body-specific SBDB/CAD/taxonomy/spectra/mission data before resource promotion.",
          "linkedEvidenceHash": "sha256-3a4cf27fbcf60e16c76e5d5b2e16490e9dcfe393747d2678474c1f82d234af22",
          "contributionHash": "sha256-d23405c06a904d5d1e4f33ec35240bb179a08e65ed69c7c42149c071a8824cf7"
        },
        {
          "category": "source-use-rights",
          "label": "Customer report source-use clearance",
          "contributionPoints": 6.13,
          "evidenceState": "blocked-source-use-review",
          "reducerProof": "Approve source-use review packets before customer-facing redistribution or derived-value claims.",
          "linkedEvidenceHash": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57",
          "contributionHash": "sha256-b79ce22cfed14972f58df695a14e7409a7da576169983ac1c69b5a2f2cf33e4d"
        },
        {
          "category": "driver-volatility",
          "label": "Benefit/risk driver spread",
          "contributionPoints": 4.75,
          "evidenceState": "model-derived-heuristic",
          "reducerProof": "Replace broad planner scores with source-backed subsystem models and narrower uncertainty bands.",
          "linkedEvidenceHash": "sha256-3d2d82c36b7e046f9493f8b8f110374461d2bda863c9092e5df482160f350ab4",
          "contributionHash": "sha256-c792630152068637fe615b2c94e3c41940a5e11aa43a72692b38d79a7240fc31"
        },
        {
          "category": "economics-evidence",
          "label": "Dated economics source and normalization gap",
          "contributionPoints": 3.91,
          "evidenceState": "blocked-commercial-economics",
          "reducerProof": "Attach dated launch/capex/opex/market sources and calibrated economics artifacts.",
          "linkedEvidenceHash": "sha256-676c2d6d270fb909cf21a482178ffcf177df30d095d6c55f918afe08bf6a9297",
          "contributionHash": "sha256-1a1448b9e48171836408d94ef9da0b8e81bd738ec922514a13a77f4ed29520a9"
        }
      ],
      "reductionSequence": [
        {
          "order": 1,
          "category": "model-spread",
          "reducerProof": "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts.",
          "linkedEvidenceHash": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13"
        },
        {
          "order": 2,
          "category": "runtime-sidecar",
          "reducerProof": "Promote runtime sidecar artifacts through the sidecar validation gate.",
          "linkedEvidenceHash": "sha256-aa8df127fd6f74cef0ba42b0ee62827380c4fb8d328808fd77d0793755c90b1f"
        },
        {
          "order": 3,
          "category": "assumption-sensitivity",
          "reducerProof": "Close assumption review gates with source-backed records and rerun assumption impact ledger.",
          "linkedEvidenceHash": "sha256-7e2ab79096a0b3d5feb1133e5b4ed52de40cfb5514b14423ab0bb85be208af00"
        },
        {
          "order": 4,
          "category": "resource-evidence",
          "reducerProof": "Attach candidate/body-specific SBDB/CAD/taxonomy/spectra/mission data before resource promotion.",
          "linkedEvidenceHash": "sha256-3a4cf27fbcf60e16c76e5d5b2e16490e9dcfe393747d2678474c1f82d234af22"
        },
        {
          "order": 5,
          "category": "source-use-rights",
          "reducerProof": "Approve source-use review packets before customer-facing redistribution or derived-value claims.",
          "linkedEvidenceHash": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57"
        }
      ],
      "budgetHash": "sha256-70c464f33b48019386facb39aa0bfb479741a7cbb3dfba4dda52f3293de0512a"
    },
    {
      "scenarioId": "mars-first",
      "name": "Mars-first Conventional Expansion",
      "rank": 5,
      "deterministicUtility": 40.78,
      "utilityP10": 38.47,
      "utilityMedian": 40.76,
      "utilityP90": 42.8,
      "winProbability": 0,
      "downsideSpread": 2.29,
      "uncertaintyBudgetPoints": 44.69,
      "uncertaintyClass": "medium-uncertainty",
      "promotionAllowed": false,
      "allowedUse": "Decision-support uncertainty budgeting only; not a validated mission, investment, pricing, or resource forecast.",
      "topUncertaintyDrivers": [
        {
          "category": "runtime-sidecar",
          "label": "Trajectory/event/runtime validation gap",
          "contributionPoints": 12,
          "evidenceState": "blocked-runtime-evidence",
          "reducerProof": "Promote runtime sidecar artifacts through the sidecar validation gate.",
          "linkedEvidenceHash": "sha256-aa8df127fd6f74cef0ba42b0ee62827380c4fb8d328808fd77d0793755c90b1f",
          "contributionHash": "sha256-4412801e7de2033a3dbe1195827c35d9004cdd53eef0996b14e8692497eb77af"
        },
        {
          "category": "model-spread",
          "label": "Seeded utility downside spread",
          "contributionPoints": 10.99,
          "evidenceState": "modeled-heuristic",
          "reducerProof": "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts.",
          "linkedEvidenceHash": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
          "contributionHash": "sha256-73b99d87c128271af6a24e0fae56a71454d5ace353dec7ee58a332eeb04b00dc"
        },
        {
          "category": "assumption-sensitivity",
          "label": "Blocked or sensitive assumptions",
          "contributionPoints": 7.16,
          "evidenceState": "blocked-business-proof",
          "reducerProof": "Close assumption review gates with source-backed records and rerun assumption impact ledger.",
          "linkedEvidenceHash": "sha256-7e2ab79096a0b3d5feb1133e5b4ed52de40cfb5514b14423ab0bb85be208af00",
          "contributionHash": "sha256-6d5f5c1fdf60a3c4743279885720f52b7f46f0ffa8c83022379740cce7fad390"
        },
        {
          "category": "source-use-rights",
          "label": "Customer report source-use clearance",
          "contributionPoints": 6.13,
          "evidenceState": "blocked-source-use-review",
          "reducerProof": "Approve source-use review packets before customer-facing redistribution or derived-value claims.",
          "linkedEvidenceHash": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57",
          "contributionHash": "sha256-b79ce22cfed14972f58df695a14e7409a7da576169983ac1c69b5a2f2cf33e4d"
        }
      ],
      "contributors": [
        {
          "category": "runtime-sidecar",
          "label": "Trajectory/event/runtime validation gap",
          "contributionPoints": 12,
          "evidenceState": "blocked-runtime-evidence",
          "reducerProof": "Promote runtime sidecar artifacts through the sidecar validation gate.",
          "linkedEvidenceHash": "sha256-aa8df127fd6f74cef0ba42b0ee62827380c4fb8d328808fd77d0793755c90b1f",
          "contributionHash": "sha256-4412801e7de2033a3dbe1195827c35d9004cdd53eef0996b14e8692497eb77af"
        },
        {
          "category": "model-spread",
          "label": "Seeded utility downside spread",
          "contributionPoints": 10.99,
          "evidenceState": "modeled-heuristic",
          "reducerProof": "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts.",
          "linkedEvidenceHash": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
          "contributionHash": "sha256-73b99d87c128271af6a24e0fae56a71454d5ace353dec7ee58a332eeb04b00dc"
        },
        {
          "category": "assumption-sensitivity",
          "label": "Blocked or sensitive assumptions",
          "contributionPoints": 7.16,
          "evidenceState": "blocked-business-proof",
          "reducerProof": "Close assumption review gates with source-backed records and rerun assumption impact ledger.",
          "linkedEvidenceHash": "sha256-7e2ab79096a0b3d5feb1133e5b4ed52de40cfb5514b14423ab0bb85be208af00",
          "contributionHash": "sha256-6d5f5c1fdf60a3c4743279885720f52b7f46f0ffa8c83022379740cce7fad390"
        },
        {
          "category": "source-use-rights",
          "label": "Customer report source-use clearance",
          "contributionPoints": 6.13,
          "evidenceState": "blocked-source-use-review",
          "reducerProof": "Approve source-use review packets before customer-facing redistribution or derived-value claims.",
          "linkedEvidenceHash": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57",
          "contributionHash": "sha256-b79ce22cfed14972f58df695a14e7409a7da576169983ac1c69b5a2f2cf33e4d"
        },
        {
          "category": "driver-volatility",
          "label": "Benefit/risk driver spread",
          "contributionPoints": 5.25,
          "evidenceState": "model-derived-heuristic",
          "reducerProof": "Replace broad planner scores with source-backed subsystem models and narrower uncertainty bands.",
          "linkedEvidenceHash": "sha256-81bc9923440bb378abb0e1f0e16683f5e7d4df6014535645506f115bb13313bb",
          "contributionHash": "sha256-b6bff0ed6eb3861f470ee5ddfcf670115668245d50d93b95dd36363556b9c048"
        },
        {
          "category": "economics-evidence",
          "label": "Dated economics source and normalization gap",
          "contributionPoints": 3.16,
          "evidenceState": "blocked-commercial-economics",
          "reducerProof": "Attach dated launch/capex/opex/market sources and calibrated economics artifacts.",
          "linkedEvidenceHash": "sha256-676c2d6d270fb909cf21a482178ffcf177df30d095d6c55f918afe08bf6a9297",
          "contributionHash": "sha256-baa47896c56972de6fd8c2e9ef79a7d8eb5cdd82ca2b5f7d676f58ffaf15b9f7"
        },
        {
          "category": "resource-evidence",
          "label": "Body/feedstock composition uncertainty",
          "contributionPoints": 0,
          "evidenceState": "not-primary-driver",
          "reducerProof": "Attach candidate/body-specific SBDB/CAD/taxonomy/spectra/mission data before resource promotion.",
          "linkedEvidenceHash": "sha256-3a4cf27fbcf60e16c76e5d5b2e16490e9dcfe393747d2678474c1f82d234af22",
          "contributionHash": "sha256-66a069c6ea75e49cd6d2dc4dfdd1078bc5dc1ae19021a2541d08c9194cf287c0"
        }
      ],
      "reductionSequence": [
        {
          "order": 1,
          "category": "runtime-sidecar",
          "reducerProof": "Promote runtime sidecar artifacts through the sidecar validation gate.",
          "linkedEvidenceHash": "sha256-aa8df127fd6f74cef0ba42b0ee62827380c4fb8d328808fd77d0793755c90b1f"
        },
        {
          "order": 2,
          "category": "model-spread",
          "reducerProof": "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts.",
          "linkedEvidenceHash": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13"
        },
        {
          "order": 3,
          "category": "assumption-sensitivity",
          "reducerProof": "Close assumption review gates with source-backed records and rerun assumption impact ledger.",
          "linkedEvidenceHash": "sha256-7e2ab79096a0b3d5feb1133e5b4ed52de40cfb5514b14423ab0bb85be208af00"
        },
        {
          "order": 4,
          "category": "source-use-rights",
          "reducerProof": "Approve source-use review packets before customer-facing redistribution or derived-value claims.",
          "linkedEvidenceHash": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57"
        },
        {
          "order": 5,
          "category": "driver-volatility",
          "reducerProof": "Replace broad planner scores with source-backed subsystem models and narrower uncertainty bands.",
          "linkedEvidenceHash": "sha256-81bc9923440bb378abb0e1f0e16683f5e7d4df6014535645506f115bb13313bb"
        }
      ],
      "budgetHash": "sha256-48d87d02b127f7fc2148ebb78c5d2cef3929bf3650408bb38914aa658a5dd173"
    },
    {
      "scenarioId": "mercury-polar",
      "name": "Mercury Polar Surface-first",
      "rank": 6,
      "deterministicUtility": 37.95,
      "utilityP10": 34.02,
      "utilityMedian": 37.73,
      "utilityP90": 41.65,
      "winProbability": 0,
      "downsideSpread": 3.72,
      "uncertaintyBudgetPoints": 64.95,
      "uncertaintyClass": "high-uncertainty",
      "promotionAllowed": false,
      "allowedUse": "Decision-support uncertainty budgeting only; not a validated mission, investment, pricing, or resource forecast.",
      "topUncertaintyDrivers": [
        {
          "category": "model-spread",
          "label": "Seeded utility downside spread",
          "contributionPoints": 16,
          "evidenceState": "modeled-heuristic",
          "reducerProof": "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts.",
          "linkedEvidenceHash": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
          "contributionHash": "sha256-3a6bcd76e44b465731a5a7391ff59f7e8c4b01803bf85738d9eeacfda0260026"
        },
        {
          "category": "assumption-sensitivity",
          "label": "Blocked or sensitive assumptions",
          "contributionPoints": 12.18,
          "evidenceState": "blocked-business-proof",
          "reducerProof": "Close assumption review gates with source-backed records and rerun assumption impact ledger.",
          "linkedEvidenceHash": "sha256-7e2ab79096a0b3d5feb1133e5b4ed52de40cfb5514b14423ab0bb85be208af00",
          "contributionHash": "sha256-3b063b187963ef7fdcff3cab7471cc8248af9a172602d565ae776b10366e99cc"
        },
        {
          "category": "runtime-sidecar",
          "label": "Trajectory/event/runtime validation gap",
          "contributionPoints": 12,
          "evidenceState": "blocked-runtime-evidence",
          "reducerProof": "Promote runtime sidecar artifacts through the sidecar validation gate.",
          "linkedEvidenceHash": "sha256-aa8df127fd6f74cef0ba42b0ee62827380c4fb8d328808fd77d0793755c90b1f",
          "contributionHash": "sha256-4412801e7de2033a3dbe1195827c35d9004cdd53eef0996b14e8692497eb77af"
        },
        {
          "category": "resource-evidence",
          "label": "Body/feedstock composition uncertainty",
          "contributionPoints": 10.4,
          "evidenceState": "blocked-resource-promotion",
          "reducerProof": "Attach candidate/body-specific SBDB/CAD/taxonomy/spectra/mission data before resource promotion.",
          "linkedEvidenceHash": "sha256-3a4cf27fbcf60e16c76e5d5b2e16490e9dcfe393747d2678474c1f82d234af22",
          "contributionHash": "sha256-9e4d02974fb4ab05d2fb6acbadc7d88c08f2d052378c2f7f7e5bc448f8e84f95"
        }
      ],
      "contributors": [
        {
          "category": "model-spread",
          "label": "Seeded utility downside spread",
          "contributionPoints": 16,
          "evidenceState": "modeled-heuristic",
          "reducerProof": "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts.",
          "linkedEvidenceHash": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
          "contributionHash": "sha256-3a6bcd76e44b465731a5a7391ff59f7e8c4b01803bf85738d9eeacfda0260026"
        },
        {
          "category": "assumption-sensitivity",
          "label": "Blocked or sensitive assumptions",
          "contributionPoints": 12.18,
          "evidenceState": "blocked-business-proof",
          "reducerProof": "Close assumption review gates with source-backed records and rerun assumption impact ledger.",
          "linkedEvidenceHash": "sha256-7e2ab79096a0b3d5feb1133e5b4ed52de40cfb5514b14423ab0bb85be208af00",
          "contributionHash": "sha256-3b063b187963ef7fdcff3cab7471cc8248af9a172602d565ae776b10366e99cc"
        },
        {
          "category": "runtime-sidecar",
          "label": "Trajectory/event/runtime validation gap",
          "contributionPoints": 12,
          "evidenceState": "blocked-runtime-evidence",
          "reducerProof": "Promote runtime sidecar artifacts through the sidecar validation gate.",
          "linkedEvidenceHash": "sha256-aa8df127fd6f74cef0ba42b0ee62827380c4fb8d328808fd77d0793755c90b1f",
          "contributionHash": "sha256-4412801e7de2033a3dbe1195827c35d9004cdd53eef0996b14e8692497eb77af"
        },
        {
          "category": "resource-evidence",
          "label": "Body/feedstock composition uncertainty",
          "contributionPoints": 10.4,
          "evidenceState": "blocked-resource-promotion",
          "reducerProof": "Attach candidate/body-specific SBDB/CAD/taxonomy/spectra/mission data before resource promotion.",
          "linkedEvidenceHash": "sha256-3a4cf27fbcf60e16c76e5d5b2e16490e9dcfe393747d2678474c1f82d234af22",
          "contributionHash": "sha256-9e4d02974fb4ab05d2fb6acbadc7d88c08f2d052378c2f7f7e5bc448f8e84f95"
        },
        {
          "category": "source-use-rights",
          "label": "Customer report source-use clearance",
          "contributionPoints": 6.13,
          "evidenceState": "blocked-source-use-review",
          "reducerProof": "Approve source-use review packets before customer-facing redistribution or derived-value claims.",
          "linkedEvidenceHash": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57",
          "contributionHash": "sha256-b79ce22cfed14972f58df695a14e7409a7da576169983ac1c69b5a2f2cf33e4d"
        },
        {
          "category": "driver-volatility",
          "label": "Benefit/risk driver spread",
          "contributionPoints": 4.25,
          "evidenceState": "model-derived-heuristic",
          "reducerProof": "Replace broad planner scores with source-backed subsystem models and narrower uncertainty bands.",
          "linkedEvidenceHash": "sha256-8bcef4c6d0b17543fd330abfe053478152e09a623045d677ca24c9f669159934",
          "contributionHash": "sha256-20f238214ceb14813a94686b1b9fad9cdf9259d8ec3341c92962f7e31722c227"
        },
        {
          "category": "economics-evidence",
          "label": "Dated economics source and normalization gap",
          "contributionPoints": 3.99,
          "evidenceState": "blocked-commercial-economics",
          "reducerProof": "Attach dated launch/capex/opex/market sources and calibrated economics artifacts.",
          "linkedEvidenceHash": "sha256-676c2d6d270fb909cf21a482178ffcf177df30d095d6c55f918afe08bf6a9297",
          "contributionHash": "sha256-60b65f5ad743b371b54e24dc4cd8c767502e20c78e0fbd5950b30fd1226b09be"
        }
      ],
      "reductionSequence": [
        {
          "order": 1,
          "category": "model-spread",
          "reducerProof": "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts.",
          "linkedEvidenceHash": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13"
        },
        {
          "order": 2,
          "category": "assumption-sensitivity",
          "reducerProof": "Close assumption review gates with source-backed records and rerun assumption impact ledger.",
          "linkedEvidenceHash": "sha256-7e2ab79096a0b3d5feb1133e5b4ed52de40cfb5514b14423ab0bb85be208af00"
        },
        {
          "order": 3,
          "category": "runtime-sidecar",
          "reducerProof": "Promote runtime sidecar artifacts through the sidecar validation gate.",
          "linkedEvidenceHash": "sha256-aa8df127fd6f74cef0ba42b0ee62827380c4fb8d328808fd77d0793755c90b1f"
        },
        {
          "order": 4,
          "category": "resource-evidence",
          "reducerProof": "Attach candidate/body-specific SBDB/CAD/taxonomy/spectra/mission data before resource promotion.",
          "linkedEvidenceHash": "sha256-3a4cf27fbcf60e16c76e5d5b2e16490e9dcfe393747d2678474c1f82d234af22"
        },
        {
          "order": 5,
          "category": "source-use-rights",
          "reducerProof": "Approve source-use review packets before customer-facing redistribution or derived-value claims.",
          "linkedEvidenceHash": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57"
        }
      ],
      "budgetHash": "sha256-6557cf089ad444fcf5ed0be5797ebfedf1cac7d3b4976f5e92033b629b50e386"
    }
  ],
  "ledgerHash": "sha256-bc5d03c9507915ce3a6f2edfaf280eb7198445b0f5c015397a1893ba27342596"
}
;
